module.exports = __webpack_public_path__ + "da66c8da5cf189c303b5dd10fef23c59.png";